
import * as React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { DataGrid } from '@mui/x-data-grid'; // Import DataGrid
import Paper from '@mui/material/Paper';
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { CSVLink } from 'react-csv'; // Import CSVLink
import Button from '@mui/material/Button';
import { useState } from 'react';

export default function DataGridTable({ tableData, appliedUniversities, appliedTerms, appliedTimelines, appliedPrograms, appliedmilestonetype, appliedmilestone }) {
  const navigate = useNavigate(); // Initialize useNavigate


  const handleRowClick = (params) => {
    // Navigate to the detail page using the sno as a parameter
    // navigate(`/individalunitreport` , { state: { UnitName: params.row.UnitName , unit_id: params.row.unit_id, appliedUniversities: appliedUniversities, appliedTerms: appliedTerms, appliedTimelines: appliedTimelines,appliedPrograms:appliedPrograms,appliedmilestonetype:appliedmilestonetype,appliedmilestone:appliedmilestone } }); // Adjust the route as needed
    // navigate(`/individalunitreport` , { state: { UnitName: params.row.UnitName , unit_id: params.row.unit_id, appliedUniversities: 'null', appliedTerms: 'null', appliedTimelines: 'null',appliedPrograms:'null',appliedmilestonetype:'null',appliedmilestone:'null' } }); // Adjust the route as needed
    navigate(`/individalunitreport`, { state: { UnitName: params.row.UnitName, unit_id: params.row.unit_id, appliedUniversities: appliedUniversities, appliedTerms: appliedTerms, appliedTimelines: appliedTimelines, appliedPrograms: appliedPrograms } }); // Adjust the route as needed

  };


  const columns = [
    {
      field: 'sno', headerName: 'S.no', width: 100,
      sortable: false, // Prevent sorting on S.No
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1
    },
    { field: 'UnitName', headerName: 'Unit', width: 300 },
    { field: 'studentengaged', headerName: '  % Students Engaged', width: 250, headerAlign: 'center' },
    {
      field: 'engaged', headerName: 'Students Engaged in 1-1 Sessions (%)', width: 200,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        return <div style={{ color: value < params.row.callqualitythrusholdengagement ? "red" : "inherit" }}>{value.toFixed(0)}%</div>;
      },
    },
    { field: 'AvgConvTimePercall', headerName: 'Avg. 1-1 Session Duration (Min)', width: 200,

      
      renderCell: (params) => {
        const value = parseFloat(params.value);
        return <div style={{ color: value < params.row.call_duration_threshold ? "red" : "inherit" }}>{value.toFixed(1)}</div>;
      },
     },

    {
      field: 'AvgConvTimePerStudent', headerName: 'Avg. Time Spent in 1-1 Sessions Per Student (Mins)', width: 250,
      // renderCell: (params) => {
      //   const value = parseFloat(params.value);
      //   return <div style={{ color: value < params.row.call_duration_threshold ? "red" : "inherit" }}>{value.toFixed(1)}</div>;
      // },

    },
    { field: 'totalonetoonesessions', headerName: 'Total 1-1 Sessions', width: 200 },
    { field: 'numberofgroupsessions', headerName: 'Total Groups Sessions', width: 200 },
    { field: 'weekstudent', headerName: 'Students Marked Behind-Track (%)', width: 200 },
    { field: 'responsiveness', headerName: 'Messages Responded to in 60 min (%)', width: 270,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        return <div style={{ color: value < params.row.responsivenessthrushold ? "red" : "inherit" }}>{value.toFixed(0)}</div>;
      },
     },
    // { field: 'redflags', headerName: ' Calls With Red Flags (%) ', width: 200 },
    // { field: 'TeachersWithComplianceFlags', headerName: 'Teachers with Compliance Flags (%)', width: 200 },
    { field: 'AvgGradingQualityScore', headerName: 'Avg. Grading Quality Score', width: 200 },
    // { field: 'AverageCallTime', headerName: 'Average Call Time (Mins)', width: 200 },
    // {
    //   field: "viewdetails",
    //   headerName: "View Details",
    //   width: 150,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <IconButton
    //       onClick={() => handleRowClick(params)}
    //       color="primary"
    //       type="button"
    //       className="conv-view-btn"
    //     >
    //       <VisibilityIcon />
    //     </IconButton>
    //   )
    // }
  ];
  // Check if tableData is valid before mapping
  const rows = (tableData || []).map((item, index) => ({
    id: item.unit_id,
    sno: index + 1,
    UnitName: item.name,
    unit_id: item.unit_id,
    weekstudent: item.percentage_weak_students,
    totalonetoonesessions: item.total_sessions,
    numberofgroupsessions: item.total_group_sessions,
    engaged: item.percentage_phone_video_engaged,
    studentengaged: item.student_engaged,
    AvgConvTimePerStudent: item.average_call_time,
    call_duration_threshold: item.call_duration_threshold,
    AvgConvTimePercall: item.average_call_per_call,
    responsiveness: `${item.message_responsiveness}%`,
    redflags: item.total_flags_count,
    AvgGradingQualityScore: item.assessment_grading,
    TeachersWithComplianceFlags: item.total_teachers_count_red_flags,
    AverageCallTime: item.average_call_time,
    callqualitythrusholdengagement: item.call_engagement_threshold,
    calldurationththrushold: item.call_duration_threshold,
    responsivenessthrushold: item.responsiveness_threshold

  }));

  // Prepare data for CSV download
  const csvData = [
    ["S.no", "Unit Name", "Weak Students (% of Total)", "Phone/Video Engagement (% Milestone Week)", "Student Engagement (% Milestone Week)", "Avg Conversation Time Per Student (Mins)", "LF Responsiveness total (milestone week)", "Red Flag Calls (% of Total, Milestone Week)", "Avg. Grading Quality Score (Assessment Number)", "Teachers with Compliance Flags (% of Total in Unit)", "Average Call Time (Mins)"],
    ...rows.map(row => [row.sno, row.UnitName, row.totalonetoonesessions, row.numberofgroupsessions, row.weekstudent, row.engaged, row.studentengaged, row.AvgConvTimePerStudent, row.responsiveness, row.redflags, row.AvgGradingQualityScore, row.TeachersWithComplianceFlags, row.AverageCallTime])
  ];

  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Starts at the first page
    pageSize: 20, // Shows 20 rows by default
  });

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
      <div style={{ width: "100%" }}>
        <div className="d-flex justify-content-end mb-2">
          {/* <CSVLink
          data={csvData}
          filename={"unit_metrics_report.csv"}
          className="btn" 
          style={{ border: '1px solid #ddd',width:'fit-content', borderRadius: '6px', padding: '4px 8px' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
          </svg>
        </CSVLink> */}
        </div>
        {/* <DataGrid
        rows={rows}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        rowCount={rows.length} // Ensure correct total row count
        pageSizeOptions={[20, 50, 100]} // Available page sizes
        onRowClick={handleRowClick}
        sx={{
          fontFamily: "Nunito Sans, sans-serif",
          fontSize: "14px",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#ebebeb",
            color: "#000",
            fontWeight: "bold",
            fontSize: "14px",
            padding: "6px",
            fontFamily: "Nunito Sans, sans-serif",
          },
          "& .MuiDataGrid-cell": {
            padding: "6px",
            fontFamily: "Nunito Sans, sans-serif",
            fontSize: "14px",
          },
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
            backgroundColor: "#f5f5f5",
          },
        }}
      /> */}
        <DataGrid
          rows={rows}
          columns={columns}
          paginationModel={paginationModel}
          onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
          autoHeight
          rowCount={rows.length}
          pageSizeOptions={[20, 50, 100]}
          onRowClick={handleRowClick}
          sx={{
            fontFamily: "Nunito Sans, sans-serif",
            fontSize: "14px",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#ebebeb",
              color: "#000",
              fontWeight: "bold",
              fontSize: "14px",
              padding: "6px",
              fontFamily: "Nunito Sans, sans-serif",
            },
            "& .MuiDataGrid-cell": {
              padding: "6px",
              fontFamily: "Nunito Sans, sans-serif",
              fontSize: "14px",
            },
            "& .MuiDataGrid-row:hover": {
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
            },
            "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
              textAlign: "center", // Default center alignment
            },
            "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus": {
              outline: "none",
            },

            // Left align specific columns
            "& .MuiDataGrid-columnHeader[data-field='sno'], & .MuiDataGrid-cell[data-field='sno']": {
              justifyContent: "flex-start",
              textAlign: "left",
            },
            "& .MuiDataGrid-columnHeader[data-field='UnitName'], & .MuiDataGrid-cell[data-field='UnitName']": {
              justifyContent: "flex-start",
              textAlign: "left",
            },
            "& .MuiDataGrid-columnHeader[data-field='university'], & .MuiDataGrid-cell[data-field='university']": {
              justifyContent: "flex-start",
              textAlign: "left",
            },

            // Ensure "% Students Engaged" is left-aligned
            "& .MuiDataGrid-columnHeader[data-field='studentengaged'], & .MuiDataGrid-cell[data-field='studentengaged']": {
              justifyContent: "center",
              textAlign: "center",
            },
          }}
        />

      </div>
    </Paper>
  );
}



